class App {
    init() {
        // Add loaded to body and delete spinner
        document.body.classList.add('loaded');

        if (document.querySelector('#main-nav')) {
            import('./js-components/mainNav.js')
                .then(({ default: initMainNav }) => {
                    initMainNav();
                })
                .catch((err) => {
                    console.error('Erreur lors du chargement de mainNav.js', err);
                });
        }

        if (
            document.querySelector('#circle-slides-wrapper') ||
            document.querySelector('.gsap-line-draw') ||
            document.querySelector('.back-line') ||
            document.querySelector('.small-float-img')
        ) {
            import('./js-components/gsapCircleSlides.js')
                .then(({ default: initGsapCircleSlides }) => {
                    initGsapCircleSlides();
                })
                .catch((err) => {
                    console.error('Erreur lors du chargement de initGsapCircleSlides.js', err);
                });
        }

        if (document.querySelectorAll('[data-scroll-to]').length) {
            import('./js-components/scrollTo.js')
                .then(({ default: initScrollTo }) => {
                    initScrollTo();
                })
                .catch((err) => {
                    console.error('Erreur lors du chargement de scrollTo.js', err);
                });
        }

        if (document.querySelectorAll('[data-stats]').length) {
            import('./js-components/initStats.js')
                .then(({ default: initStats }) => {
                    initStats();
                })
                .catch((err) => {
                    console.error('Erreur lors du chargement de initStats.js', err);
                });
        }

        if (document.querySelectorAll('.glightbox').length) {
            import('./js-components/glightboxGlobalPlayers.js')
                .then(({ default: initGlightboxGlobalPlayers }) => {
                    initGlightboxGlobalPlayers();
                })
                .catch((err) => {
                    console.error('Erreur lors du chargement de glightboxGlobalPlayers.js', err);
                });
        }

        if (document.querySelectorAll('.lottie[data-lottie]').length) {
            import('./js-components/lottieAnims.js')
                .then(({ default: initLottieAnims }) => {
                    initLottieAnims();
                })
                .catch((err) => {
                    console.error('Erreur lors du chargement de lottieAnims.js', err);
                });
        }

        if (document.querySelectorAll('.lottie-block').length) {
            import('./js-components/lottieBlocksAnims.js')
                .then(({ default: initLottieBlocksAnims }) => {
                    initLottieBlocksAnims();
                })
                .catch((err) => {
                    console.error('Erreur lors du chargement de lottieAnims.js', err);
                });
        }

        if (document.querySelectorAll('[data-init-flickity]').length) {
            import('./js-components/flickitySliders.js')
                .then(({ default: initFlickitySliders }) => {
                    initFlickitySliders();
                })
                .catch((err) => {
                    console.error('Erreur lors du chargement de flickitySliders.js', err);
                });
        }

        if (document.querySelectorAll('.faq-title').length) {
            import('./js-components/faqModules.js')
                .then(({ default: initFaqModules }) => {
                    initFaqModules();
                })
                .catch((err) => {
                    console.error('Erreur lors du chargement de faqModules.js', err);
                });
        }

        // HomePage video
        let isMobile = true;
        isMobile = window.matchMedia('(max-width: 767px)').matches;

        const videosRefs = document.querySelectorAll('[data-load-video]');

        if (isMobile.value) {
            return;
        }

        // Delay videos load
        setTimeout(() => {
            // videoRef.setAttribute('src', videoRef.getAttribute('data-src'));

            videosRefs.forEach((videoRef) => {
                videoRef.setAttribute('src', videoRef.getAttribute('data-src'));
            });
        }, 10);

        const timelineLineWrap = document.querySelector('.timeline-line-wrap');

        if (timelineLineWrap) {
            // When in viewport, add class to animate line
            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            timelineLineWrap.classList.add('is-in-viewport');
                        } else {
                            timelineLineWrap.classList.remove('is-in-viewport');
                        }
                    });
                },
                { threshold: 0.5 }
            );

            observer.observe(timelineLineWrap);
        }

        const countupElements = document.querySelectorAll('[data-countup]');

        if (countupElements.length) {
            import('./js-components/countup.js')
                .then(({ default: initCountup }) => {
                    initCountup(countupElements);
                })
                .catch((err) => {
                    console.error('Erreur lors du chargement de countup.js', err);
                });
        }
    }
}

export default new App();
